export default (state, action) => {
    switch (action.type) {
        case 'SAVE_INTERVENTIONS_DATA':
            return action.data;
        default:
            return state || null;
    }
};
